module.exports = __webpack_public_path__ + "static/img/Tutorial sin texto Redpie4 (1)-8.0021c36c.jpg";